import { format } from "date-fns";

export default class MyCommon {
  constructor() {}

  myformat(
    date: string | number | Date | null | undefined,
    formatString: string
  ): string {
    if (!date) {
      return "";
    }

    return format(date, formatString);
  }

  formatDate(dateString: string) {
    if (!dateString) return null;
    const date = new Date(dateString);
    const isoDate = date.toISOString().split("T")[0];
    return isoDate;
  }

  converDateFormat(value, formatString) {
    if (!value || !/^\d{8}$/.test(value)) return "";

    const year = parseInt(value.substring(0, 4), 10);
    const month = parseInt(value.substring(4, 6), 10);
    const day = parseInt(value.substring(6, 8), 10);

    const date = new Date(year, month - 1, day);

    return format(date, formatString);
  }

  isNullOrEmpty(value: string | any | null | undefined): boolean {
    return (
      value === null || value === undefined || value.toString().trim() === ""
    );
  }

  nullOrEmptyToConv(
    value: string | any | null | undefined,
    value2: string
  ): string {
    const isNull: boolean =
      value === null || value === undefined || value.toString().trim() === "";
    if (isNull) {
      return value2;
    } else {
      return value;
    }
  }

  isNumber(value: number | null | undefined | any): boolean {
    if (!value || Number.isNaN(value)) {
      return false;
    } else {
      return true;
    }
  }

  nullOrEmptyToNumber(
    value: number | null | undefined | any,
    value2: number
  ): number {
    if (!value || Number.isNaN(value)) {
      return Number(value2);
    } else {
      return Number(value);
    }
  }

  getMonth(value: number | null | undefined | any): string {
    if (!value || Number.isNaN(value)) {
      if (this.isNullOrEmpty(value)) {
        return "";
      } else {
        return "1";
      }
    } else {
      return (Number(value) + 1).toString();
    }
  }

  nullToDate(value: Date | null | undefined | any, value2: Date): Date {
    if (this.isDate(value)) {
      return new Date(value);
    } else {
      return value2;
    }
  }

  getConvToAPIDate(dtmDate: Date | null | undefined): string {
    if (this.isDate(dtmDate)) {
      const y = dtmDate?.getFullYear();
      const m = String(dtmDate!.getMonth() + 1).padStart(2, "0");
      const strDate = `${y}-${m}-01`;
      return strDate;
    } else {
      return "";
    }
  }

  getTeikyoTuki = (
    teikyotuki: Date | string | any | null | undefined
  ): Date | null => {
    let dtmDate: Date = new Date();

    if (this.isDate(teikyotuki)) {
      if (typeof teikyotuki === "string") {
        dtmDate = new Date(teikyotuki); // Parse string into Date
      } else if (teikyotuki instanceof Date) {
        dtmDate = teikyotuki; // Use the Date instance directly
      } else if (
        !Number.isNaN(teikyotuki.year) &&
        !Number.isNaN(teikyotuki.month)
      ) {
        dtmDate = new Date(`${teikyotuki.year}/${teikyotuki.month + 1}/01`);
      } else {
        return null;
      }
    } else {
      return null;
    }

    // Set the date to the first day of the month and time to 00:00:00
    dtmDate.setDate(1);
    dtmDate.setHours(0, 0, 0, 0); // Explicitly set milliseconds to 0
    return dtmDate;
  };

  convertDate = (
    dtmDate: Date | string | any | null | undefined
  ): Date | null => {
    let date: Date = new Date();

    if (this.isDate(dtmDate)) {
      if (typeof dtmDate === "string") {
        date = new Date(dtmDate); // Parse string into Date
      } else if (dtmDate instanceof Date) {
        date = dtmDate; // Use the Date instance directly
      } else if (!Number.isNaN(dtmDate.year) && !Number.isNaN(dtmDate.month)) {
        date = new Date(`${dtmDate.year}/${dtmDate.month + 1}/01`);
      } else {
        return null;
      }
    } else {
      return null;
    }

    // Set the date to the first day of the month and time to 00:00:00
    date.setHours(0, 0, 0, 0); // Explicitly set milliseconds to 0
    return date;
  };

  convertDateTime = (
    dtmDate: Date | string | any | null | undefined
  ): Date | null => {
    let date: Date = new Date();

    if (this.isDate(dtmDate)) {
      if (typeof dtmDate === "string") {
        date = new Date(dtmDate); // Parse string into Date
      } else if (dtmDate instanceof Date) {
        date = dtmDate; // Use the Date instance directly
      } else {
        return null;
      }
    } else {
      return null;
    }

    // Set the date to the first day of the month and time to 00:00:00
    //date.setHours(0, 0, 0, 0); // Explicitly set milliseconds to 0
    return date;
  };

  setMonthPicker(teikyotuki: Date | string | any | null | undefined) {
    const dtmDate: Date | null = this.getTeikyoTuki(teikyotuki);
    if (dtmDate != null) {
      const month = {
        month: dtmDate.getMonth(),
        year: dtmDate.getFullYear(),
      };
      return month;
    }
    {
      return null;
    }
  }

  getMonthPicker(teikyotuki: Date | any | null): Date | null {
    let dtmDate: Date;

    if (teikyotuki) {
      if (teikyotuki instanceof Date) {
        dtmDate = new Date(
          `${teikyotuki.getFullYear()}/${teikyotuki.getMonth() + 1}/01`
        );
      } else if (typeof teikyotuki === "string") {
        dtmDate = new Date(teikyotuki);
      } else if (
        !Number.isNaN(teikyotuki.year) &&
        !Number.isNaN(teikyotuki.month)
      ) {
        dtmDate = new Date(`${teikyotuki.year}/${teikyotuki.month + 1}/01`);
      } else {
        //dtmDate = new Date(`${teikyotuki.year}/${teikyotuki.month + 1}/01`);
        return null;
      }
      dtmDate.setDate(1);
      dtmDate.setHours(0, 0, 0, 0); // Explicitly set milliseconds to 0
      return dtmDate;
    } else {
      return null;
    }
  }

  //クライアントからはローカル時刻でサーバー送信
  //サーバーはクラアントから受け取った時刻データを自動的にUTC時刻に変換
  //クライアントはサーバーから受け取った日付を明示的にローカル時刻へ変換

  //クライアントからサーバーUTCへ変換（変換しないへ訂正）
  convertLocalToUtc(
    localDate: Date | null | undefined
  ): Date | null | undefined {
    // if (!localDate) return localDate;
    // const date: Date = new Date(localDate);
    // date.setHours(9, 0, 0, 0); // 時を9に、分と秒を0に設定します。

    // return date;
    if (!localDate) return null;

    const date: Date = new Date(localDate);
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    // 00:00（時分秒は0にする) UTCとして送る（サーバーでは DateTime として受ける）
    //return new Date(year, month, day);
    return new Date(Date.UTC(year, month, day));
  }

  // convertLocalToUtcHours(
  //   localDate: Date | null | undefined
  // ): Date | null | undefined {
  //   if (!localDate) return localDate;
  //   const date: Date = new Date(localDate);
  //   date.setHours(date.getHours() + 9, date.getMinutes(), 0); // 時を9に、分と秒を0に設定します。

  //   return date;
  // }

  convertLocalToUtcHours(
    localDate: Date | null | undefined
  ): Date | null | undefined {
    if (!localDate) return localDate;

    const date = new Date(localDate);
    date.setMinutes(0, 0, 0); // 分・秒・ミリ秒を0にする
    //return date;
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  }

  // 使っていない
  convertLocalToUtcMinutes(
    localDate: Date | null | undefined
  ): Date | null | undefined {
    if (!localDate) return localDate;

    const date = new Date(localDate);
    date.setSeconds(0, 0); // 秒を0にする
    //return date;
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  }

  //サーバーからクライアントUTCからLocal変換
  convertUtcToLocal(utcDate: Date | null | undefined): Date | null {
    if (!utcDate) return null;
    const date = new Date(utcDate);
    // 現在のローカルタイムゾーンのオフセットを適用してローカル時間に変換
    //return date;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  }

  //サーバーからクライアントUTCからLocal変換 使っていない
  convertUtcToLocalExceptTime(utcDate: Date | null | undefined): Date | null {
    const local = this.convertUtcToLocal(utcDate);
    if (!local) return null;
    local.setHours(0, 0, 0, 0);
    return local;
  }

  // ジェネリックを使った日付変換の共通関数
  convertDates = <T>(item: T, fields: (keyof T)[]): T => {
    fields.forEach((field) => {
      if (item[field]) {
        // @ts-ignore: ここで型チェックが厳しいため、コンパイル時に警告を無視
        item[field] = value.convertUTCToJST(item[field]);
      }
    });
    return item;
  };

  // グループ化関係の共通メソッド（ジェネリックにて実装）
  groupItems<TKey, TElement>(
    lists: Array<Array<TElement>>
  ): Array<{
    item: TElement;
    groupCd: number;
    groupRank: number;
    groupCount: number;
  }> {
    // グループ内の要素を処理し、結果を出力する
    const groupLists = lists
      .filter((group) => group.length > 0) // Where(g => g.Any()) 相当
      .flatMap((group, index) =>
        group.map((item, itemIndex) => ({
          item: item,
          groupCd: index + 1, // Group単位で採番
          groupRank: itemIndex + 1, // Group内(注番単位)の順位
          groupCount: group.length, // Group内のカウント
        }))
      );

    return groupLists;
  }

  formatDateToYYYYMMDD(date: Date | null | undefined): string {
    if (!date) return "";

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月は0から始まるため+1
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}${month}${day}`;
  }

  formatDateToYYYYMMDD2(date: Date | null | undefined): string {
    if (!date) return "";

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月は0から始まるため+1
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}/${month}/${day}`;
  }

  formatDateToYYYYMMDD3(date: Date | null | undefined): string {
    if (!date) return "";

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月は0から始まるため+1
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  formatDateToYYYYMMDD4(date: Date | null | undefined): string {
    if (!date) return "";
    const dtmDate = new Date(date);

    const year = dtmDate.getFullYear();
    const month = (dtmDate.getMonth() + 1).toString().padStart(2, "0"); // 月は0から始まるため+1
    const day = dtmDate.getDate().toString().padStart(2, "0");

    return `${year}年${month}月${day}日`;
  }

  getTimeHHMM(date: Date | string | null | undefined): string {
    if (!date) {
      // date が null または undefined の場合、空文字を返す
      return "";
    }

    if (typeof date === "string") {
      // 時間部分のみを抽出する正規表現
      const timeMatch = date.match(/^(\d{2}):(\d{2})(:\d{2})?$/);
      if (timeMatch) {
        return `${timeMatch[1]}:${timeMatch[2]}`;
      }
    }

    const dtmDate = new Date(date);

    return (
      dtmDate.toLocaleTimeString("ja-JP", {
        hour: "2-digit", // 時間を2桁で表示 (例: 09)
        minute: "2-digit", // 分を2桁で表示 (例: 05)
        hour12: false, // 24時間形式を使用
      }) ?? ""
    );
  }

  /**
   * TimePickerに整形
   * @param strDate
   * @returns
   */
  setTimePicker(strDate: string | null | undefined) {
    if (!strDate) {
      return null;
    }

    const [hours, minutes] = strDate.split(":").map(Number);

    const timeObject = {
      hours,
      minutes,
    };

    return timeObject;
  }

  setDateToConvTimePicker(dtmDate: Date | null | undefined, offSet: number) {
    if (!dtmDate) {
      return null;
    }

    const date = new Date(dtmDate);

    const timeObject = {
      hours: date.getHours() - offSet,
      minutes: date.getMinutes(),
    };

    return timeObject;
  }

  isDate(date: any): boolean {
    if (date == undefined || date == null) return false;
    return !Number.isNaN(new Date(date).getDate());
  }

  getUniqueStr(myStrong?: number): string {
    let strong = 1000;
    if (myStrong) strong = myStrong;
    return (
      new Date().getTime().toString(16) +
      Math.floor(strong * Math.random()).toString(16)
    );
  }

  getLastMonth(dtmDate: Date | null): Date | null {
    if (dtmDate != null) {
      const date: Date = new Date(
        dtmDate.getFullYear(),
        dtmDate.getMonth() + 1,
        0
      );
      date.setHours(0, 0, 0, 0);
      return date;
    } else {
      return null;
    }
  }

  getFirstMonth(dtmDate: Date | null): Date | null {
    if (dtmDate != null) {
      const date: Date = dtmDate;
      date.setDate(1);
      date.setHours(0, 0, 0, 0);
      return date;
    } else {
      return null;
    }
  }

  getFirstDate(dtmDate: Date | null | undefined): Date | null {
    if (dtmDate) {
      const date: Date = new Date(dtmDate);
      date.setHours(0, 0, 0, 0);
      return date;
    } else {
      return null;
    }
  }

  getLastDate(dtmDate: Date | null | undefined): Date | null {
    if (dtmDate) {
      const date: Date = new Date(dtmDate);
      date.setHours(23, 59, 59, 0);
      return date;
    } else {
      return null;
    }
  }

  calculateMonthsBetween(startDate: Date | null, endDate: Date | null): number {
    // 開始日と終了日が null の場合は 0 を返す
    if (!startDate || !endDate) {
      return 0;
    }

    // 年と月を考慮して月数を計算
    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth(); // 0から始まる (0=1月, 11=12月)
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth();

    // 計算: (終了年 - 開始年) * 12 + (終了月 - 開始月)
    const monthsDifference =
      (endYear - startYear) * 12 + (endMonth - startMonth);

    return monthsDifference;
  }

  /**
   *
   * @param dtmDate
   * @param hour
   * @param minutes
   * @returns
   */
  getDateTime(
    dtmDate: Date | string | any | null | undefined,
    hour: number,
    minutes: number
  ): Date | null {
    if (this.isDate(dtmDate)) {
      // 新しい Date オブジェクトを作成
      const date: Date = new Date(dtmDate);
      date.setHours(hour, minutes, 0);
      return date;
    } else {
      return null;
    }
  }

  /**
   *
   * @param dtmDate
   * @returns
   */
  getLastDay(dtmDate: Date | string | any | null | undefined): number {
    const date: Date | null = this.getLastMonth(this.convertDate(dtmDate));

    if (date) {
      return date.getDate();
    } else {
      return 31;
    }
  }

  /*
   * 基準日時点の年齢
   * @param birthDate 生年月日
   * @param referenceDate 基準日
   * @returns 日付の差分
   */
  calculateAge(
    birthDate: Date | null | undefined,
    referenceDate: Date | null | undefined
  ): number {
    // 引数が有効か確認
    if (!birthDate || !referenceDate) {
      return 0;
    }

    // 生年月日と基準日をそれぞれ年、月、日で取得
    const birthYear = birthDate.getFullYear();
    const birthMonth = birthDate.getMonth(); // 0 = 1月
    const birthDay = birthDate.getDate();

    const referenceYear = referenceDate.getFullYear();
    const referenceMonth = referenceDate.getMonth(); // 0 = 1月
    const referenceDay = referenceDate.getDate();

    // 年齢を計算
    let age = referenceYear - birthYear;

    // 基準日が生年月日より前の月または日であれば年齢を1引く
    if (
      referenceMonth < birthMonth ||
      (referenceMonth === birthMonth && referenceDay < birthDay)
    ) {
      age--;
    }

    return age;
  }

  /**
   * 四捨五入関数
   * @param value 数値
   * @scale 有効桁数
   * @returns 四捨五入した数値
   */
  customRound(value: number | null | undefined, scale: number): number {
    if (!value) {
      return 0;
    }
    return value >= 0
      ? Math.round(value * 10 ** scale) / 10 ** scale
      : -Math.round(-value * 10 ** scale) / 10 ** scale;
  }

  /**
   * 切り捨て関数
   * @param value 数値
   * @scale 有効桁数
   * @returns 切り捨てた数値
   */
  customFloor(value: number | null | undefined, scale: number): number {
    if (!value) {
      return 0;
    }
    return value >= 0
      ? Math.floor(value * 10 ** scale) / 10 ** scale
      : -Math.floor(-value * 10 ** scale) / 10 ** scale;
  }

  /**
   * 切り上げ関数
   * @param value 数値
   * @scale 有効桁数
   * @returns 切り上げた数値
   */
  customCeil(value: number | null | undefined, scale: number): number {
    if (!value) {
      return 0;
    }
    return value >= 0
      ? Math.ceil(value * 10 ** scale) / 10 ** scale
      : -Math.ceil(-value * 10 ** scale) / 10 ** scale;
  }

  /**
   * 数値を通貨フォーマットに変換
   * @param value 数値
   * @returns 通貨フォーマットの文字列
   */
  getCurrencyFormat(value: number): string {
    return value.toLocaleString("ja-JP", {
      style: "currency",
      currency: "JPY",
    });
  }

  /**
   * 数値をポイントに変換
   * @param value 数値
   * @returns ポイントに変換した数値
   *
   */

  mmToPt(mm: number): number {
    const pointsPerInch = 72; // 1インチ = 72ポイント
    const mmPerInch = 25.4; // 1インチ = 25.4ミリメートル
    return (mm / mmPerInch) * pointsPerInch;
  }

  /**
   * 曜日を取得する
   * @param date
   * @returns
   */
  getWeekdayName(date: Date | null | undefined): string {
    if (!date) {
      return "";
    }

    const dtmDate = new Date(date);

    const list = {
      ja: ["日", "月", "火", "水", "木", "金", "土"],
    };
    const day: number = date.getDay();
    return list.ja[day];
  }

  /**
   * 曜日を取得する
   * @param date
   * @returns
   */
  getWeekdayNameByMonth(pdateMonth: Date, pday: number): string {
    const date: Date = new Date(pdateMonth);
    date.setDate(date.getDate() + pday - 1);

    const list = {
      ja: ["日", "月", "火", "水", "木", "金", "土"],
    };
    const day: number = date.getDay();
    return list.ja[day];
  }

  getWeekdayByMonth(pdateMonth: Date, pday: number): number {
    const date: Date = new Date(pdateMonth);
    date.setDate(date.getDate() + pday - 1);
    const day: number = date.getDay();
    return day;
  }

  /**
   * 和暦を取得する
   * @param date
   * @returns
   * @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
   */
  getEraDate(date: Date | null | undefined): string {
    if (!date) return "";

    return date.toLocaleString("ja-JP-u-ca-japanese", {
      year: "numeric",
      month: "long", // 月の表示を調整 (例: "1月", "一月")
      day: "numeric",
      era: "short", // 和暦の元号を短く表示
    });
  }

  toJapaneseEra(
    date: Date | null | undefined
  ): { era: string; year: number; month: number; day: number } | null {
    if (!date) {
      return null;
    }

    const options: Intl.DateTimeFormatOptions = {
      era: "short", // 元号を短縮形で表示 (例: 令和, 平成)
      year: "numeric", // 年を表示
      month: "numeric", // 月を表示
      day: "numeric", // 日を表示
    };

    // 和暦形式でフォーマット
    const formatted = date.toLocaleString("ja-JP-u-ca-japanese", options);

    // フォーマット結果の分解
    const match = formatted.match(
      /(明治|大正|昭和|平成|令和)(\d+)\/(\d+)\/(\d+)/
    );

    if (match) {
      return {
        era: match[1], // 元号 (例: 令和)
        year: parseInt(match[2]), // 年 (例: 5)
        month: parseInt(match[3]), // 月 (例: 6)
        day: parseInt(match[4]), // 日 (例: 1)
      };
    }
    return null;
  }

  /**
   * 循環参照を無視してオブジェクトを文字列に変換
   * @param obj
   * @returns
   */
  safeStringify(obj: any) {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return undefined; // 循環参照を無視
        }
        seen.add(value);
      }
      return value;
    });
  }

  /**
   * 日付リストの生成
   * @param date hid
   * @returns
   */

  generateMonthDays(date: Date): Date[] {
    const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
    const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const dates: Date[] = [];

    while (startDate <= endDate) {
      //const dtmDate=startDate;
      dates.push(new Date(startDate));
      //dates.push(startDate.toISOString().split('T')[0]); // YYYY-MM-DD形式
      startDate.setDate(startDate.getDate() + 1);
    }
    return dates;
  }

  /**
   * BlobをBase64に変換
   * @param dblob: Blob
   * @returns
   */
  async blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  splitByByteLength(text: string, maxBytes: number): string {
    const lines = text.split(/\r?\n/); // 既存の改行コードで分割
    const result: string[] = [];

    for (const line of lines) {
      let currentLine = "";
      let currentBytes = 0;

      for (const char of line) {
        let charBytes = new Blob([char]).size; // 文字のバイト数を取得
        if (charBytes >= 2) {
          charBytes = 2;
        }

        if (currentBytes + charBytes > maxBytes) {
          result.push(currentLine); // 現在の行を結果に追加
          currentLine = char; // 新しい行を開始
          currentBytes = charBytes; // バイト数をリセット
        } else {
          currentLine += char;
          currentBytes += charBytes;
        }
      }
      result.push(currentLine); // 最後の行も追加
    }

    return result.join("\n");
  }

  convArrayByByteLength(text: string, maxBytes: number): string[] {
    const lines = text.split(/\r?\n/); // 既存の改行コードで分割
    const result: string[] = [];

    for (const line of lines) {
      let currentLine = "";
      let currentBytes = 0;

      for (const char of line) {
        let charBytes = new Blob([char]).size; // 文字のバイト数を取得
        if (charBytes >= 2) {
          charBytes = 2;
        }

        if (currentBytes + charBytes > maxBytes) {
          result.push(currentLine); // 現在の行を結果に追加
          currentLine = char; // 新しい行を開始
          currentBytes = charBytes; // バイト数をリセット
        } else {
          currentLine += char;
          currentBytes += charBytes;
        }
      }
      result.push(currentLine); // 最後の行も追加
    }

    return result;
  }

  getArrayToResult(parray: Array<number | null | undefined>): number {
    let result: number = 0;
    for (let i = 0; i < parray.length; i++) {
      if (this.nullOrEmptyToNumber(parray[i], 0) >= 1) {
        result = 1;
        break;
      }
    }
    return result;
  }

  /**
   * CSVデータ用に改行コードを除去し、指定文字数だけ返す
   */
  getCsvData(strText: string | null | undefined, count: number): string {
    if (!strText) {
      return "";
    }

    // 改行コード（\r, \n）をすべて除去
    strText = strText.replace(/[\r\n]/g, "");

    // 指定文字数だけ切り取り
    return strText.substring(0, count);
  }
}
